import React from 'react';
import { Upload as AntUpload } from 'antd';

/**
 * Wrapper component for Ant Design Upload
 * 
 * This wrapper allows us to easily replace Ant Design in the future without changing all imports.
 * It preserves all Ant Design Upload functionality and sub-components.
 * 
 * @component
 * @example
 * import { Upload } from '../GeneralComponents/ui';
 * 
 * <Upload>
 *   <Button>Upload</Button>
 * </Upload>
 * 
 * // Dragger
 * <Upload.Dragger>
 *   <p>Drag files here</p>
 * </Upload.Dragger>
 * 
 * @see https://ant.design/components/upload/ - Ant Design Upload documentation
 */
const Upload = AntUpload;

export default Upload;

